import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { BaseTagFieldCard } from '../../../../styled';
import { ITagField, onTagRemoveClickHandler } from '../../../../types';
import { useGradientBorderStyles } from '../../../../hooks/useGradientBorderStyles';

export interface EnhancedTagFieldProps {
  field: ITagField;
  onTagRemoveClick: onTagRemoveClickHandler;
}

export const EnhancedTagField: FC<EnhancedTagFieldProps> = () => {
  const { boxBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: '#fff'
  });

  // ! render
  return (
    <BaseTagFieldCard className={boxBorderGradientClass}>
      <SText style={{ width: '100%', textAlign: 'center' }}>
        No keywords available
      </SText>
    </BaseTagFieldCard>
  );
};
